import "@fontsource/noto-sans-jp"
import "./src/styles/base.css"
import "./src/styles/blog-contents-style.css"

export const onClientEntry = () => {
  if (typeof document === "undefined") return
  document.documentElement.classList.add("js")
}

export const onRouteUpdate = () => {
  if (typeof document === "undefined") return

  // =========================
  // 1) fadeIn系
  // =========================
  const fadeTargets = document.querySelectorAll(
    ".fadeInUp, .fadeInLeft, .fadeInRight"
  )

  const fadeObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        entry.target.classList.add("on")
        fadeObserver.unobserve(entry.target)
      })
    },
    { threshold: 0.1 }
  )

  fadeTargets.forEach((el) => fadeObserver.observe(el))

  // =========================
  // 2) js-reveal
  // =========================
  const revealTargets = document.querySelectorAll(".js-reveal")
  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        requestAnimationFrame(() => entry.target.classList.add("is-in"))
        revealObserver.unobserve(entry.target)
      })
    },
    { threshold: 0.25 }
  )

  revealTargets.forEach((el) => revealObserver.observe(el))

  // =========================
  // 3) comVisual
  // =========================
  const comVisuals = document.querySelectorAll(".comVisual")
  comVisuals.forEach((el) => {
    requestAnimationFrame(() => el.classList.add("is-in"))
  })
}